import React from "react";
import {
  FooterWrapper,
  FooterHeader,
  FooterDescription,
  FooterSocial,
  FooterAuthority,
  FooterContainer,
  FooterItems,
  FooterItem,
} from "./style";
import { AiOutlineTwitter, AiFillMail, AiFillFile } from "react-icons/ai";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterHeader data-aos="fade-down">
          Questions or collaboration ideas?{" "}
        </FooterHeader>
        <FooterDescription data-aos="fade-down" data-aos-delay="300">
          Join our ever-growing Community
        </FooterDescription>
        <FooterSocial>
          <FooterItems>
            <FooterItem data-aos="fade-up">
              <a
                href="mailto:contact@stellartai.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <AiFillMail fontSize={"32px"} />
              </a>
            </FooterItem>
            <FooterItem data-aos="fade-up">
              <a
                href="https://twitter.com/stellart_ai"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <AiOutlineTwitter fontSize={"32px"} />
              </a>
            </FooterItem>
            <FooterItem data-aos="fade-up">
              <a
                href="https://docs.stellartai.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <AiFillFile fontSize={"32px"} />
              </a>
            </FooterItem>
            {/* <FooterItem>
        <a href="discord" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>
            <AiFillFile fontSize={'32px'} />
        </a>
    </FooterItem> */}
          </FooterItems>
        </FooterSocial>
        <FooterAuthority>
          <p>
            © 2023 <span>Stellart</span>, All rights reserved.
          </p>
          <Link
            to="/termsofservice"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <p>Terms of Service</p>
          </Link>
        </FooterAuthority>
      </FooterContainer>
    </FooterWrapper>
  );
};

export default Footer;
